import { Badge } from './Badge'
import { Icon } from './Icon'
import styles from './AutopilotBadge.module.css'

export interface AutopilotBadgeProps {
  size?: 'sm' | 'md'
  label?: string
}

export function AutopilotBadge({ size = 'md', label }: AutopilotBadgeProps) {
  return (
    <Badge
      tone="green"
      pill={size === 'md'}
      className={size === 'sm' ? styles.small : styles.medium}
      data-component="autopilot-badge"
    >
      {size === 'md' ? <Icon name="sparkle" size={13} strokeWidth={2} /> : null}
      {size === 'md' ? label ?? 'AI 托管中' : 'AI 托管'}
    </Badge>
  )
}
